import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BookType } from 'xlsx/types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { __importDefault } from 'tslib';


@Component({
  selector: 'app-import-dialog',
  templateUrl: './import-dialog.component.html',
  styleUrls: ['./import-dialog.component.scss']
})
export class ImportDialogComponent implements OnInit {

  @Input() public title: string;
  @Input() public exampleDownloadPath: string;
  @Input() public options: Map<string, string[]>;
  @Input() public importStatus: { name: string, status: 'ok' | 'fehler' | 'loading' | 'wait' }[];
  @Input() public importFelder: { type: string, felder: string}[];

  @Output() public optionSelected: EventEmitter<{key: string, option: string}> = new EventEmitter<{key: string, option: string}>();
  @Output() public uploadComplete: EventEmitter<XLSX.WorkBook> = new EventEmitter<XLSX.WorkBook>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() { 
  }

  public close(){
    this.activeModal.close();
  }

  public optionChange(optionKey, newValue){
    this.optionSelected.emit({key: optionKey, option: newValue});
  }

  public handleFileUpload(files: FileList){
    if(files.length !== 1){
      return;
    }

    const reader = new FileReader();
    reader.onload = e => {
      const data = new Uint8Array((e.target as any).result as any);
      const workbook = XLSX.read(data, {type: 'array'});

      this.uploadComplete.emit(workbook);
      //(document.getElementById("upload") as HTMLInputElement).value = "";
    };
    reader.readAsArrayBuffer(files[0]);
  }
}
